<template>
  <div>
    <ValidationObserver ref="form" #default="{ dirty, valid }">
      <div>
        <button type="button" @click="onPickFile" class="form__item btn btn--primary" style="margin-top: 30px">{{ $t(selectLabel) }}</button>
        <ValidationProvider :name="name" rules="image|ext:jpeg,jpg,png|size:10240" v-slot="{ errors, validate }">
          <div class="margin--top padding--none">
            <div class="" :class="{'input__group--red': errors.length > 0}">
              <input type="file" @change="validate" ref="image" :name="name" :accept="accept" @input="onFilePicked">
            </div>
            <span class="form__notice text--red"
                  :class="{'form__notice--active': errors.length > 0}">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  name: 'FileInput',
  $_veeValidate: {
    value () {
      return this.value
    }
  },
  props: {
    name: {
      type: String
    },
    model: {
      type: [String, File]
    },
    accept: {
      type: String,
      default: '*'
    },
    error: {
      type: Boolean,
      required: false
    },
    errorMessages: {
      type: Array
    },
    selectLabel: {
      type: String,
      default: 'Select image'
    },
    removeLabel: {
      type: String,
      default: 'Remove'
    }
  },

  data () {
    return {
      value: '',
      imageUrl: '',
      files: []
    }
  },

  watch: {
    value (v) {
      this.imageUrl = v
    },
    model (value) {
      if (value === null) {
        this.removeFile()
      }
    }
  },

  mounted () {
    this.imageUrl = this.model
  },

  methods: {
    onPickFile () {
      this.$refs.image.click()
    },

    onFilePicked (event) {
      const files = event.target.files || event.dataTransfer.files

      if (files && files[0]) {
        let filename = files[0].name

        if (filename && filename.lastIndexOf('.') <= 0) {
          return // return alert('Please add a valid image!')
        }

        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.imageUrl = fileReader.result
          this.$emit('picChanged', fileReader.result)
        })
        fileReader.readAsDataURL(files[0])

        this.files = Array.from(files)
        this.value = this.files
        this.$emit('input', this.files)
      }
    },

    removeFile () {
      this.files = []
      this.$refs.image.value = null
      this.value = this.files
      this.$nextTick(() => {
        this.$emit('input', this.files)
        this.imageUrl = ''
      })
    }
  }
}
</script>

<style scoped>
  input[type=file] {
    position: absolute;
    left: -99999px;
  }
</style>
